module.exports = __webpack_public_path__ + "img/consult-with-the-doctor-th.52374601.png";